// pages/NewConversation.js - VERSION TRADUITE + CSS MODULES
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './NewConversation.module.css';
import { API_BASE_URL } from '../config';

const NewConversation = () => {
  const { t } = useTranslation(['newconversation', 'common']);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
// APRÈS
const [formData, setFormData] = useState({
  name: '',
  city: '',           // ⭐ AJOUTER
  platform: 'instagram',
  objective: 'discussion',
  key_info: ''
});

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      const girl_info = {
        name: formData.name,
        city: formData.city,  // ⭐ AJOUTER
        platform: formData.platform,
        objective: formData.objective,
        key_info: formData.key_info,
        detected_interests: '',
        detected_personality: '',
        communication_style: ''
      };

      const response = await fetch(`${API_BASE_URL}/conversations`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          title: formData.name,
          girl_info: girl_info
        })
      });

      const data = await response.json();

      if (response.ok) {
        navigate(`/conversation/${data.conversation.id}`);
      } else {
        setError(data.message || t('newconversation:errors.creation_failed'));
      }
    } catch (err) {
      setError(t('newconversation:errors.connection_error'));
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // Plateformes avec traduction dynamique
  const platforms = [
    { value: 'instagram', emoji: '📸' },
    { value: 'tinder', emoji: '🔥' },
    { value: 'tiktok', emoji: '🎵' },
    { value: 'snapchat', emoji: '👻' },
    { value: 'real_life', emoji: '🤝' },
    { value: 'autre', emoji: '💬' }
  ];

  // Objectifs avec traduction dynamique
  const objectives = [
    { value: 'discussion', icon: '💬' },
    { value: 'numero', icon: '📱' },
    { value: 'date', icon: '☕' },
    { value: 'flexible', icon: '🤷‍♂️' }
  ];

  return (
    <div className={styles["new-conversation-page"]}>
      <div className={styles["new-conversation-container"]}>
        
        {/* Header */}
        <div className={styles["conversation-header"]}>
          <button 
            className={styles["btn-back"]}
            onClick={() => navigate('/dashboard')}
            disabled={loading}
          >
            {t('newconversation:header.back_button')}
          </button>
          <h1>{t('newconversation:header.title')}</h1>
          <p className={styles["subtitle"]}>
            {t('newconversation:header.subtitle')}
          </p>
        </div>

        {/* Formulaire */}
        <form onSubmit={handleSubmit} className={styles["conversation-form"]}>
          
          {/* Erreur */}
          {error && (
            <div className={`${styles["alert"]} ${styles["alert-error"]}`}>
              <span className={styles["alert-icon"]}>⚠️</span>
              <span>{error}</span>
            </div>
          )}

          {/* Prénom */}
          <div className={styles["form-section"]}>
            <label className={styles["form-label"]}>
              <span className={styles["label-text"]}>
                {t('newconversation:form.name_label')}
              </span>
              <span className={styles["label-required"]}>
                {t('newconversation:form.name_required')}
              </span>
            </label>
            <input 
              type="text" 
              className={styles["form-input"]}
              placeholder={t('newconversation:form.name_placeholder')}
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              required
              disabled={loading}
            />
          </div>

          {/* ⭐⭐⭐ VILLE (NOUVEAU) ⭐⭐⭐ */}
            <div className={styles["form-section"]}>
              <label className={styles["form-label"]}>
                <span className={styles["label-text"]}>
                  📍 {t('newconversation:form.city_label')}
                </span>
              </label>
              <input 
                type="text" 
                className={styles["form-input"]}
                placeholder={t('newconversation:form.city_placeholder')}
                value={formData.city}
                onChange={(e) => setFormData({...formData, city: e.target.value})}
                disabled={loading}
              />
              <small className={styles["form-hint"]}>
                {t('newconversation:form.city_hint')}
              </small>
            </div>

          {/* Plateforme */}
          <div className={styles["form-section"]}>
            <label className={styles["form-label"]}>
              <span className={styles["label-text"]}>
                {t('newconversation:form.platform_label')}
              </span>
              <span className={styles["label-required"]}>
                {t('newconversation:form.platform_required')}
              </span>
            </label>
            <div className={styles["platform-grid"]}>
              {platforms.map((platform) => (
                <button
                  key={platform.value}
                  type="button"
                  className={`${styles["platform-card"]} ${formData.platform === platform.value ? styles["active"] : ''}`}
                  onClick={() => setFormData({...formData, platform: platform.value})}
                  disabled={loading}
                >
                  <span className={styles["platform-emoji"]}>{platform.emoji}</span>
                  <span className={styles["platform-label"]}>
                    {t(`newconversation:platforms.${platform.value}`)}
                  </span>
                </button>
              ))}
            </div>
          </div>

          {/* Objectif */}
          <div className={styles["form-section"]}>
            <label className={styles["form-label"]}>
              <span className={styles["label-text"]}>
                {t('newconversation:form.objective_label')}
              </span>
              <span className={styles["label-required"]}>
                {t('newconversation:form.objective_required')}
              </span>
            </label>
            <div className={styles["objective-list"]}>
              {objectives.map((obj) => (
                <button
                  key={obj.value}
                  type="button"
                  className={`${styles["objective-item"]} ${formData.objective === obj.value ? styles["active"] : ''}`}
                  onClick={() => setFormData({...formData, objective: obj.value})}
                  disabled={loading}
                >
                  <span className={styles["objective-icon"]}>{obj.icon}</span>
                  <span className={styles["objective-label"]}>
                    {t(`newconversation:objectives.${obj.value}`)}
                  </span>
                  <span className={styles["objective-check"]}>✓</span>
                </button>
              ))}
            </div>
          </div>

          {/* Info clé */}
          <div className={styles["form-section"]}>
            <label className={styles["form-label"]}>
              <span className={styles["label-text"]}>
                {t('newconversation:form.key_info_label')}
              </span>
              <span className={styles["label-optional"]}>
                {t('newconversation:form.key_info_optional')}
              </span>
            </label>
            <textarea 
              className={styles["form-textarea"]}
              placeholder={t('newconversation:form.key_info_placeholder')}
              value={formData.key_info}
              onChange={(e) => setFormData({...formData, key_info: e.target.value})}
              rows={3}
              disabled={loading}
            />
            <p className={styles["form-hint"]}>
              {t('newconversation:form.key_info_hint')}
            </p>
          </div>

          {/* Bouton Submit */}
          <button 
            type="submit" 
            className={styles["btn-submit"]}
            disabled={loading || !formData.name}
          >
            {loading ? (
              <>
                <span className={styles["spinner"]}></span>
                {t('newconversation:form.submit_loading')}
              </>
            ) : (
              <>
                {t('newconversation:form.submit_button')}
              </>
            )}
          </button>

        </form>

      </div>
    </div>
  );
};

export default NewConversation;